var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"white_container reserved_container"},[_c('h4',[_vm._v(_vm._s(_vm.lesson.title))]),_c('h2',[_vm._v(_vm._s(_vm.lesson.header))]),_c('p',[_vm._v("Lecție indisponibilă. Vă rugăm să supliniți contul pentru a continua nivelul")]),_c('button',{staticClass:"button",on:{"click":_vm.toShop}},[_c('span',[_vm._v("Supliniți contul")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }